import {
  Stack,
  styled,
  Typography,
  useScrollTrigger,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useWatching } from "../../utils/reactQuery/users";
import {
  useGenericWorkflowStatus,
  useUserWorkflowList,
} from "../../utils/reactQuery/workflows";
import Kanban from "../myTask/components/KanbanBoard/Kanban";
import Loader from "../../components/Loader";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import manageColumnIcon from "../../styles/svg/Vector.svg";
import { debounce } from "lodash";
import { searchCard, setGridView } from "../../redux/SearchSlice";
import _ from "lodash";
import { useCustomSearchParams } from "../../hooks/useCustomSearchParams";
import { useResponsive } from "../../hooks/useResponsive";
import { dataGridColumn } from "./DataGridColumn";
import OpenCardDetail from "../board/components/Kanban/openCardDetail";
import { TooltipName } from "../../utils/Enums";
import './watching.scss'
import { ToggleColumnMenu } from "./ToggleColumnMenu";
import { DeskTopHeader } from "./DeskTopHeader";
import { ListViewTable } from "./ListViewTable";
import { MobileHeader } from "./MobileHeader";
import useBoardIdByKey from "../../hooks/useBoardIdByKey";

export default function WatchingComp() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchParam, setSearchParam, removeSearchParam] = useCustomSearchParams("txt");
  const { isLoading: genericWorkflowStepsLoading, genericWorkflowStatus: workflows, } = useGenericWorkflowStatus();
  const { userWorkflows } = useUserWorkflowList();
  const genericWorkflowId = userWorkflows?.data?.data?.responseData?.find((workflow) => workflow.is_generic)?.workflow_id;

  const { data, isLoading, isRefetching } = useWatching(genericWorkflowId);

  const dispatch = useDispatch();
  const [columns, setColumns] = useState(dataGridColumn);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [selectedColumn, setSelectedColumn] = useState({
    col1: true,
    col2: true,
    col3: true,
    col4: true,
    col5: true,
    col6: true,
    col7: true,
    col8: true,
    col9: true,
    col10: true,
    col11: true,
    col12: true,
    col13: true,
  });
  const filterUser = searchParams.get("search");
  const epicSearch = useSelector((state) => state.epic.searchEpic);
  const searchText = useSelector((state) => state.search.searchText);
  const cardId = searchParams.get("card_id");
  const [projects, setProjects] = useState([]);
  const { id } = useBoardIdByKey();
  const isMobile = useResponsive("down", "md");
  const [inputValue, setInputValue] = useState("");

  const gridView = useSelector((state) => state.search.gridView);

  const getCradStatus = (id) => {
    const tamp =
      workflows?.data?.data?.responseData?.filter(
        (ele) => ele?.workflow_step_id == id
      )[0]?.status || "";
    return tamp;
  };

  useEffect(() => {
    setInputValue(searchParam || '');
    dispatch(searchCard(searchParam || ''));
  }, [])

  const handleChange = (event) => {
    const value = event?.target?.value?.trimStart();
    setInputValue(value);
    debouncedSearch(value);
  };

  const debouncedSearch = useRef(
    _.debounce((value) => {
      dispatch(searchCard(value));
      setSearchParam("txt", value);
    }, 300) // 300ms delay
  )?.current;

  const updateSearchParams = (key, value) => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set(key, value);
    setSearchParams(newSearchParams);
  };

  const handleSelectColumn = (slec) => {
    const temp = { ...selectedColumn };
    temp[slec] = !selectedColumn[slec];
    setSelectedColumn(temp);
  };

  useEffect(() => {
    // Define the debounce delay (e.g., 300 milliseconds)
    const debounceDelay = 1000;
    let allFilteredCards = data?.data?.data?.responseData;

    // Create a debounced version of the filter function
    const debouncedFilter = debounce(() => {
      if (searchText) {
        allFilteredCards = allFilteredCards?.filter(
          (cardData) =>
            (cardData?.card?.title
              ? `${cardData?.card?.title}`?.toLowerCase()?.includes(searchText)
              : "") ||
            (cardData?.card?.assigned_to_user?.last_name
              ? `${cardData?.card?.assigned_to_user?.last_name}`
                ?.toLowerCase()
                ?.includes(searchText)
              : "") ||
            (cardData?.card?.assigned_to_user?.first_name
              ? `${cardData?.card.assigned_to_user?.first_name}`
                ?.toLowerCase()
                ?.includes(searchText)
              : "") ||
            cardData?.key?.toLowerCase()?.includes(searchText) ||
            cardData?.card?.card_id
              ?.toString()
              ?.toLowerCase()
              ?.includes(searchText) ||
            cardData?.labels?.some((ele) =>
              ele?.toLowerCase()?.includes(searchText)
            ) ||
            cardData?.card?.epic?.epic_name?.toLowerCase()?.includes(searchText)
        );
        setProjects(allFilteredCards);
      }
    }, debounceDelay);
    if (filterUser) {
      allFilteredCards = allFilteredCards?.filter(
        (el) => el?.card?.assigned_to_user_id == filterUser
      );
    }
    if (epicSearch && epicSearch?.length > 0) {
      allFilteredCards = allFilteredCards?.filter((item) =>
        epicSearch?.includes(item?.card?.epic_id)
      );
    }
    if (searchText) {
      // Call the debounced filter function whenever searchText, id, or cards change
      debouncedFilter();
    }

    setProjects(allFilteredCards);

    return () => {
      // Cleanup the debounce function on component unmount
      debouncedFilter.cancel();
    };
  }, [searchText, filterUser, epicSearch, id, data]);

  return (
    <>
      {projects && cardId && (
        <OpenCardDetail
          cardsOnBoard={projects?.map((el) => {
            return {
              ...el,
              ...el.card,
            };
          })}
        />
      )}
      {isMobile ? (
        <MobileHeader />
      ) : (
        <DeskTopHeader handleChange={handleChange} inputValue={inputValue} TooltipName={TooltipName} />
      )}
      {isLoading || isRefetching ? (
        <div className="loader-center">
          <Loader color={"black"} />
        </div>
      ) : (
        <>
          {data && !isLoading && !isRefetching && workflows
            ? gridView && (
              <Kanban
                cards={data?.data?.data?.responseData || []}
                workflowSteps={workflows?.data?.data?.responseData?.sort(
                  (a, b) => a?.step_sequence - b?.step_sequence
                )}
                isMyTaskView={true}
              />
            )
            : ""}
          {!gridView && (
            <div>
              <Stack
                direction="row"
                justifyContent="end"
                my={3}
              >
                <div onClick={(event) => setAnchorEl(event?.currentTarget)} className="d-flex align-items-center">
                  <img
                    src={manageColumnIcon}
                    width={14}
                    alt="manage column"
                    style={{ cursor: "pointer" }}
                  />
                  <Typography className="manage-board">
                    Manage Board Columns
                  </Typography>
                </div>
              </Stack>
              <ListViewTable projects={projects} columns={columns} selectedColumn={selectedColumn} getCradStatus={getCradStatus} />
            </div>
          )}
          <ToggleColumnMenu anchorEl={anchorEl} open={open} setAnchorEl={setAnchorEl} selectedColumn={selectedColumn} setSelectedColumn={setSelectedColumn} handleSelectColumn={handleSelectColumn} />
        </>
      )}
    </>
  );
}
